export default __webpack_public_path__ + "static/media/image3.ecf74270.jpg";